class GallerySliders {
  constructor() {
      if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initializeAll());
      } else {
          this.initializeAll();
      }

      window.addEventListener('popstate', () => this.handleVariantChange());

      this.observeVariantChanges();

      this.hideGalleryInitially();
  }

  hideGalleryInitially() {
      const gallery = document.querySelector('.pdp-media-gallery');
      if (gallery) {
          gallery.style.opacity = '0';
      }
  }

  showGalleryWithFadeIn() {
      const gallery = document.querySelector('.pdp-media-gallery');
      if (gallery) {
          setTimeout(() => {
              gallery.classList.add('fade-in');
          }, 100);

          setTimeout(() => {
              if (gallery.style.opacity === '0') {
                  gallery.style.opacity = '1';
                  gallery.classList.add('fade-in');
              }
          }, 1000);
      }
  }

  getCurrentVariantId() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('variant');
  }

  getCurrentVariantColor() {
      const variantId = this.getCurrentVariantId();
      if (variantId && window.productColorVariantMap) {
          return window.productColorVariantMap[variantId];
      }
      return null;
  }


  isFirstImageCorrectForVariant() {
      const currentVariantColor = this.getCurrentVariantColor();
      if (!currentVariantColor) return true;

      const desktopFirstImage = document.querySelector('.images-grid .first-image');
      const mobileFirstSlide = document.querySelector('.mobile-slider-wrapper .gallery-cell:first-child img');

      const desktopMatches = !desktopFirstImage || desktopFirstImage.getAttribute('data-color') === currentVariantColor;
      const mobileMatches = !mobileFirstSlide || mobileFirstSlide.getAttribute('data-color') === currentVariantColor;

      return desktopMatches && mobileMatches;
  }


  observeVariantChanges() {
      let currentVariantColor = this.getCurrentVariantColor();

      setInterval(() => {
          const newVariantColor = this.getCurrentVariantColor();
          if (newVariantColor !== currentVariantColor && newVariantColor) {
              currentVariantColor = newVariantColor;
              this.handleVariantChange();
          }
      }, 100);

        const variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"]');
        variantSelectors.forEach(selector => {
            selector.addEventListener('change', () => {
                setTimeout(() => {
                    this.handleVariantChange();
                    this.updateVariantSelectorStyles();
                }, 50);
            });
        });

        const variantRadios = document.querySelector('variant-radios');
        if (variantRadios) {
            variantRadios.addEventListener('change', () => {
                setTimeout(() => this.updateVariantSelectorStyles(), 50);
            });
        }

        document.addEventListener('change', (e) => {
            if (e.target && e.target.type === 'radio' &&
                (e.target.closest('.variant-radios') || e.target.closest('.swatch_options'))) {
                setTimeout(() => this.updateVariantSelectorStyles(), 50);
            }
        });

        document.addEventListener('product-info:variant-changed', () => {
            setTimeout(() => {
                this.handleVariantChange();
                this.updateVariantSelectorStyles();
            }, 50);
        });
    }

  handleVariantChange() {
      const currentVariantColor = this.getCurrentVariantColor();
      if (currentVariantColor) {
          const gallery = document.querySelector('.pdp-media-gallery');
          if (gallery) {
              gallery.style.opacity = '1';
          }

          if (!this.isFirstImageCorrectForVariant()) {
              this.reorderImagesForColor(currentVariantColor);
          }

          this.updateVariantSelectorStyles();

          setTimeout(() => {
              if (gallery) {
                  gallery.style.transition = 'opacity 0.3s ease-in-out';
                  gallery.style.opacity = '0.8';
                  setTimeout(() => {
                      gallery.style.opacity = '1';
                  }, 150);
              }
          }, 50);
      }
  }

  updateVariantSelectorStyles() {
      const variantRadios = document.querySelector('variant-radios');
      if (variantRadios && typeof variantRadios.updateVariantSelectorStyles === 'function') {
          variantRadios.updateVariantSelectorStyles();
      } else {
          const labels = document.querySelectorAll('.product_section .product_form .variant-radios .product-form__input label');
          labels.forEach((label) => {
              const radio = label.previousElementSibling;
              label.classList.toggle('selected', radio?.checked || false);
          });
      }

      let swatchElements = document.querySelectorAll('.product_section .product_form .swatch .swatch-element:not(.color)');
      if (swatchElements.length === 0) {
          swatchElements = document.querySelectorAll('.product_section .product_form .swatch-element:not(.color)');
      }
      if (swatchElements.length === 0) {
          swatchElements = document.querySelectorAll('.product_section .swatch-elements .swatch-element:not(.color)');
      }

      swatchElements.forEach((element) => {
          const label = element.querySelector('label');
          const inputId = label?.getAttribute('for');
          let input = null;

          if (inputId) {
              input = document.getElementById(inputId);
          }

          if (!input) {
              let prev = element.previousElementSibling;
              while (prev && !input) {
                  if (prev.tagName === 'INPUT' && prev.type === 'radio') {
                      input = prev;
                  }
                  prev = prev.previousElementSibling;
              }
          }

          element.classList.toggle('selected', input?.checked || false);
      });
  }

  reorderImagesForColor(color) {
      this.reorderMobileSlider(color);
      this.reorderDesktopGrid(color);
  }

  reorderMobileSlider(color) {
      const mobileGallery = document.querySelector('.mobile-slider-wrapper .js-product-gallery');
      if (!mobileGallery) return;

      const slides = Array.from(mobileGallery.querySelectorAll('.gallery-cell'));

      const targetSlide = slides.find(slide => {
          const img = slide.querySelector('img');
          if (img) {
              const slideColor = img.getAttribute('data-color') ||
                               slide.getAttribute('data-color');
              return slideColor === color;
          }
          return false;
      });

      if (targetSlide && slides[0] !== targetSlide) {
          mobileGallery.insertBefore(targetSlide, slides[0]);

          if (window.jQuery && $(mobileGallery).data('flickity')) {
              $(mobileGallery).flickity('destroy');
              const event = new CustomEvent('product-gallery-reorder', { detail: { gallery: mobileGallery } });
              document.dispatchEvent(event);
          }
      }
  }

  reorderDesktopGrid(color) {
      const imagesGrid = document.querySelector('.images-grid');
      if (!imagesGrid) return;

      const gridItems = Array.from(imagesGrid.querySelectorAll('[class*="grid-item-"]:not(.placeholder-image)'));

      const targetItem = gridItems.find(item =>
          item.getAttribute('data-color') === color
      );

      if (targetItem && gridItems[0] !== targetItem) {
          const firstItem = gridItems[0];

          const parent = targetItem.parentNode;
          const targetNextSibling = targetItem.nextSibling;

          parent.insertBefore(targetItem, firstItem);
          parent.insertBefore(firstItem, targetNextSibling);

          this.updateGridItemClasses();

          gridItems.forEach(item => item.classList.remove('first-image'));
          targetItem.classList.add('first-image');
      }
  }

  updateGridItemClasses() {
      const imagesGrid = document.querySelector('.images-grid');
      if (!imagesGrid) return;

      const gridItems = Array.from(imagesGrid.querySelectorAll('[class*="grid-item-"]:not(.placeholder-image)'));

      gridItems.forEach((item, index) => {
          const classList = Array.from(item.classList);
          classList.forEach(className => {
              if (className.startsWith('grid-item-')) {
                  item.classList.remove(className);
              }
          });

          item.classList.add(`grid-item-${index + 1}`);
      });
  }

  desktopModal() {
      const modal = document.getElementById('image-modal');
      const modalImage = document.getElementById('modal-image-desktop');
      const modalContent = document.querySelector('.modal-content');
      const closeModal = document.querySelector('.close-modal');
      const triggers = document.querySelectorAll('.modal-trigger');

      if (!modal || !modalImage || !closeModal) return;

      triggers.forEach(trigger => {
          trigger.addEventListener('click', function () {
              const isVideo = this.classList.contains('video-container') || this.querySelector('video');

              if (isVideo) {
                  const video = this.querySelector('video');
                  if (video) {
                      modalImage.style.display = 'none';
                      const videoElement = video.cloneNode(true);
                      videoElement.controls = false;
                      videoElement.autoplay = true;
                      videoElement.loop = true;
                      videoElement.muted = true;
                      videoElement.style.width = 'auto';
                      videoElement.style.height = '100%';
                      videoElement.style.maxWidth = '100%';
                      videoElement.style.maxHeight = '80vh';

                      const existingVideo = modal.querySelector('.modal-content video');
                      if (existingVideo) {
                          existingVideo.remove();
                      }

                      const modalContent = modal.querySelector('.modal-content');
                      modalContent.appendChild(videoElement);

                      modal.classList.remove('hidden');
                      modal.classList.add('modal-enter');
                      setTimeout(() => {
                          modal.classList.add('modal-enter-active');
                          modal.classList.remove('modal-enter');
                      }, 10);
                  }
              } else {
                  const existingVideo = modal.querySelector('.modal-content video');
                  if (existingVideo) {
                      existingVideo.remove();
                  }

                  modalImage.style.display = 'block';
                  modalImage.src = this.src;
                  modal.classList.remove('hidden');
                  modal.classList.add('modal-enter');
                  setTimeout(() => {
                      modal.classList.add('modal-enter-active');
                      modal.classList.remove('modal-enter');
                  }, 10);
              }
          });
      });

      closeModal.addEventListener('click', function () {
          closeWithAnimation();
      });

      modalContent.addEventListener('click', function () {
          closeWithAnimation();
      });

      modal.addEventListener('click', function (e) {
          if (e.target === modal) {
              closeWithAnimation();
          }
      });

      function closeWithAnimation() {
          modal.classList.add('modal-exit-active');
          modal.classList.remove('modal-enter-active');
          setTimeout(() => {
              modal.classList.add('hidden');
              modal.classList.remove('modal-exit-active');
          }, 300);
      }
  }



  initializeAll() {
      this.desktopModal();

      const initialVariantColor = this.getCurrentVariantColor();
      if (initialVariantColor) {
          this.handleVariantChange();
          setTimeout(() => this.showGalleryWithFadeIn(), 200);
      } else {
          this.showGalleryWithFadeIn();
      }
  }
}

let gallerySlider = new GallerySliders();
window.gallerySliders = gallerySlider;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        if (gallerySlider && typeof gallerySlider.updateVariantSelectorStyles === 'function') {
            setTimeout(() => gallerySlider.updateVariantSelectorStyles(), 100);
        }
    });
} else {
    setTimeout(() => {
        if (gallerySlider && typeof gallerySlider.updateVariantSelectorStyles === 'function') {
            gallerySlider.updateVariantSelectorStyles();
        }
    }, 100);
}
